import { MouseEvent, ReactNode, useCallback } from 'react';

import { cx } from '@libs/classnames';
import { useClickOutside } from '@libs/hooks/useClickOutside';
import { useOnEscape } from '@libs/hooks/useOnKeyDown';
import { Card } from '@ui/components/Card';
import { IconButton } from '@ui/components/IconButton';
import { Modal } from '@ui/components/Modal';
import { DeleteIcon } from '@ui/icons/DeleteIcon';

import styles from './ModalCard.module.css';

/**
 * Здесь нету open специально. Просто не рендерь компонент в разметке, если хочешь, чтобы он был закрыт.
 * Так проще работать с clickOutside и прочими событиями.
 * Все равно анимаций пока нет. Если будет - доделаем.
 */
type Props = {
  className?: string;
  modalClassName?: string;
  contentClassName?: string;
  title: string;
  onClose?: () => void;
  children: ReactNode;
};
export function ModalCard({
  className,
  modalClassName,
  contentClassName,
  title,
  onClose,
  children,
}: Props) {
  const ref = useClickOutside<HTMLDivElement>(() => onClose?.(), {
    enabled: !!onClose,
  });
  useOnEscape(onClose);

  // Cancel click outside
  const onCardClick = useCallback((e: MouseEvent) => e.stopPropagation(), []);

  return (
    <Modal open className={modalClassName}>
      <Card
        ref={ref}
        className={cx(styles.modalCard, className)}
        onClick={onCardClick}
        onPointerDown={onCardClick}
      >
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          <IconButton onClick={onClose}>
            <DeleteIcon />
          </IconButton>
        </div>
        <div className={cx(styles.content, contentClassName)}>{children}</div>
      </Card>
    </Modal>
  );
}
